"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reduxForm = require("redux-form");
var _reactRedux = require("react-redux");
var _ReceiveFormComponent = _interopRequireDefault(require("./ReceiveFormComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var userEmail = state.user.userInfo.Email;
  return {
    userEmail: userEmail
  };
};
var ReceiveForm = (0, _reduxForm.reduxForm)({
  form: 'ReceiveForm',
  onSubmit: function onSubmit() {}
})(_ReceiveFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, null)(ReceiveForm);